/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  Journey,
  JourneyBody,
  JourneyForUser,
  QuestDisplay,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    JourneyFromJSON,
    JourneyToJSON,
    JourneyBodyFromJSON,
    JourneyBodyToJSON,
    JourneyForUserFromJSON,
    JourneyForUserToJSON,
    QuestDisplayFromJSON,
    QuestDisplayToJSON,
} from '../models/index';

export interface CreateJourneysRequest {
    journeyBody?: JourneyBody;
}

export interface DeleteJourneysIdRequest {
    id: string;
}

export interface GetJourneysIdRequest {
    id: string;
}

export interface GetJourneysUserRequest {
    surface?: QuestDisplay;
}

export interface UpdateJourneysIdRequest {
    id: string;
    journeyBody?: JourneyBody;
}

/**
 * JourneysApi - interface
 * 
 * @export
 * @interface JourneysApiInterface
 */
export interface JourneysApiInterface {
    /**
     * Create a Journey (the admin editor\'s authoring wrapper — segment membership + canvas layout). Edges live on each segment quest\'s prerequisites.
     * @param {JourneyBody} [journeyBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JourneysApiInterface
     */
    createJourneysRaw(requestParameters: CreateJourneysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Journey>>;

    /**
     * Create a Journey (the admin editor\'s authoring wrapper — segment membership + canvas layout). Edges live on each segment quest\'s prerequisites.
     */
    createJourneys(requestParameters: CreateJourneysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Journey>;

    /**
     * Delete a Journey (the authoring wrapper only — the segment quests and their prerequisites are untouched).
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JourneysApiInterface
     */
    deleteJourneysIdRaw(requestParameters: DeleteJourneysIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a Journey (the authoring wrapper only — the segment quests and their prerequisites are untouched).
     */
    deleteJourneysId(requestParameters: DeleteJourneysIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * List all Journeys for the admin editor.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JourneysApiInterface
     */
    getJourneysRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Journey>>>;

    /**
     * List all Journeys for the admin editor.
     */
    getJourneys(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Journey>>;

    /**
     * Get a single Journey by id (membership + canvas layout). The editor derives edges from the segments\' quest prerequisites.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JourneysApiInterface
     */
    getJourneysIdRaw(requestParameters: GetJourneysIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Journey>>;

    /**
     * Get a single Journey by id (membership + canvas layout). The editor derives edges from the segments\' quest prerequisites.
     */
    getJourneysId(requestParameters: GetJourneysIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Journey>;

    /**
     * The authored journeys a player can travel on a surface, each with its segments in track order. The player card uses this for position-in-track (\"segment 2 of 4\"), which cannot be derived from the surfaced quests alone — one-at-a-time sequencing drops every resolved segment before the client sees it.
     * @param {QuestDisplay} [surface] Platform surface to fetch journeys for (e.g. PLAY_PAGE). Omitted &#x3D; every active journey.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JourneysApiInterface
     */
    getJourneysUserRaw(requestParameters: GetJourneysUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<JourneyForUser>>>;

    /**
     * The authored journeys a player can travel on a surface, each with its segments in track order. The player card uses this for position-in-track (\"segment 2 of 4\"), which cannot be derived from the surfaced quests alone — one-at-a-time sequencing drops every resolved segment before the client sees it.
     */
    getJourneysUser(requestParameters: GetJourneysUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<JourneyForUser>>;

    /**
     * Update a Journey (rename, retrack, edit segment membership + canvas layout, activate/deactivate). Edge changes are saved on the segment quests\' prerequisites, not here.
     * @param {string} id 
     * @param {JourneyBody} [journeyBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JourneysApiInterface
     */
    updateJourneysIdRaw(requestParameters: UpdateJourneysIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Journey>>;

    /**
     * Update a Journey (rename, retrack, edit segment membership + canvas layout, activate/deactivate). Edge changes are saved on the segment quests\' prerequisites, not here.
     */
    updateJourneysId(requestParameters: UpdateJourneysIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Journey>;

}

/**
 * 
 */
export class JourneysApi extends runtime.BaseAPI implements JourneysApiInterface {

    /**
     * Create a Journey (the admin editor\'s authoring wrapper — segment membership + canvas layout). Edges live on each segment quest\'s prerequisites.
     */
    async createJourneysRaw(requestParameters: CreateJourneysRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Journey>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/journeys`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: JourneyBodyToJSON(requestParameters['journeyBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JourneyFromJSON(jsonValue));
    }

    /**
     * Create a Journey (the admin editor\'s authoring wrapper — segment membership + canvas layout). Edges live on each segment quest\'s prerequisites.
     */
    async createJourneys(requestParameters: CreateJourneysRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Journey> {
        const response = await this.createJourneysRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a Journey (the authoring wrapper only — the segment quests and their prerequisites are untouched).
     */
    async deleteJourneysIdRaw(requestParameters: DeleteJourneysIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteJourneysId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/journeys/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a Journey (the authoring wrapper only — the segment quests and their prerequisites are untouched).
     */
    async deleteJourneysId(requestParameters: DeleteJourneysIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteJourneysIdRaw(requestParameters, initOverrides);
    }

    /**
     * List all Journeys for the admin editor.
     */
    async getJourneysRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Journey>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/journeys`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(JourneyFromJSON));
    }

    /**
     * List all Journeys for the admin editor.
     */
    async getJourneys(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Journey>> {
        const response = await this.getJourneysRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get a single Journey by id (membership + canvas layout). The editor derives edges from the segments\' quest prerequisites.
     */
    async getJourneysIdRaw(requestParameters: GetJourneysIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Journey>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getJourneysId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/journeys/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JourneyFromJSON(jsonValue));
    }

    /**
     * Get a single Journey by id (membership + canvas layout). The editor derives edges from the segments\' quest prerequisites.
     */
    async getJourneysId(requestParameters: GetJourneysIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Journey> {
        const response = await this.getJourneysIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The authored journeys a player can travel on a surface, each with its segments in track order. The player card uses this for position-in-track (\"segment 2 of 4\"), which cannot be derived from the surfaced quests alone — one-at-a-time sequencing drops every resolved segment before the client sees it.
     */
    async getJourneysUserRaw(requestParameters: GetJourneysUserRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<JourneyForUser>>> {
        const queryParameters: any = {};

        if (requestParameters['surface'] != null) {
            queryParameters['surface'] = requestParameters['surface'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Optional", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/journeys/user`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(JourneyForUserFromJSON));
    }

    /**
     * The authored journeys a player can travel on a surface, each with its segments in track order. The player card uses this for position-in-track (\"segment 2 of 4\"), which cannot be derived from the surfaced quests alone — one-at-a-time sequencing drops every resolved segment before the client sees it.
     */
    async getJourneysUser(requestParameters: GetJourneysUserRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<JourneyForUser>> {
        const response = await this.getJourneysUserRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a Journey (rename, retrack, edit segment membership + canvas layout, activate/deactivate). Edge changes are saved on the segment quests\' prerequisites, not here.
     */
    async updateJourneysIdRaw(requestParameters: UpdateJourneysIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Journey>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateJourneysId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/journeys/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: JourneyBodyToJSON(requestParameters['journeyBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => JourneyFromJSON(jsonValue));
    }

    /**
     * Update a Journey (rename, retrack, edit segment membership + canvas layout, activate/deactivate). Edge changes are saved on the segment quests\' prerequisites, not here.
     */
    async updateJourneysId(requestParameters: UpdateJourneysIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Journey> {
        const response = await this.updateJourneysIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
